module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-text-only",
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2.5rem",
      "font-size": ".7rem"
    }
  }, [_vm._v("\n   填写说明:\n   "), _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.custRemark))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": ".7rem",
      "margin-top": "20px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.custRemark1) + "\n  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data),
      expression: "data"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "必填"
    },
    domProps: {
      "value": (_vm.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "margin-top": "15px",
      "text-align": "center",
      "color": "white"
    }
  }, [_c('button', {
    class: {
      'close-popup': _vm.popupTrue
    },
    staticStyle: {
      "background-color": "#0a8ddf"
    },
    on: {
      "click": _vm.checkData
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "bar bar-nav"
  }, [_c('div', {
    staticClass: "button button-link button-nav pull-right close-popup"
  }, [_c('span', {
    staticClass: "icon icon-down close-popup"
  }, [_vm._v("取消")])]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_c('div', [_vm._v("备注填写")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-275eb232","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/PoPupTextBox.vue
// module id = 1573
// module chunks = 8